import { render, staticRenderFns } from "./GenresPage.vue?vue&type=template&id=897efcea&scoped=true"
import script from "./GenresPage.vue?vue&type=script&lang=js"
export * from "./GenresPage.vue?vue&type=script&lang=js"
import style0 from "./GenresPage.vue?vue&type=style&index=0&id=897efcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897efcea",
  null
  
)

export default component.exports